// La version et la date des documents légaux sont dans `constants/site.js`.

// Seuil d'exigence de l'autorisation d'un représentant légal. Miroir de
// `AGE_MAJORITE` dans `app/core/legal.py` — c'est le back qui fait foi et qui
// bloque réellement la connexion ; ici on ne fait qu'anticiper l'affichage pour
// ne pas laisser une mineure découvrir le blocage au premier login.
export const AGE_MAJORITE = 18;

// `birthDate` au format JJ/MM/AAAA (format de saisie de l'onboarding).
export const isMinorFromInput = (birthDate) => {
  if (!birthDate) return false;
  const [day, month, year] = birthDate.split('/').map(Number);
  if (!day || !month || !year) return false;

  const today = new Date();
  let age = today.getFullYear() - year;
  const birthdayPassed =
    today.getMonth() + 1 > month || (today.getMonth() + 1 === month && today.getDate() >= day);
  if (!birthdayPassed) age -= 1;

  return age < AGE_MAJORITE;
};
